module.exports = __webpack_public_path__ + "img/avatar-name-bg.632c1bcb.png";